import RowMoveManager from './slick.rowmovemanager';
export default RowMoveManager;
